import { u as F, a as W } from "./screen-breakpoint-F1gCb5WD.js";
import { u as H } from "./drawer-border-DBxafmnT.js";
import { u as T, a as U } from "./outside-click-wx59LN8I.js";
import { useState as h, useEffect as p, useCallback as b } from "react";
import { u as L } from "./virtual-scroll-DwBPDmEx.js";
import { a as z } from "./virtual-scroll-DwBPDmEx.js";
const k = {
  Forward: 1,
  Backward: 2
};
function g({ data: r, idProp: s, orderProp: n }) {
  const [o, i] = h(r);
  p(() => {
    i(r);
  }, [r]);
  const a = (t) => {
    if (t < o.length) {
      const e = o[t + 1];
      o[t + 1] = o[t], o[t] = e, i([...c()]);
    }
  }, u = (t) => {
    if (t > 0) {
      const e = o[t - 1];
      o[t - 1] = o[t], o[t] = e, i([...c()]);
    }
  }, v = (t, e) => {
    t === k.Forward ? a(e) : u(e);
  }, O = (t) => s ? o[0][s] === t[s] : o.indexOf(t) === 0, E = (t) => s ? o[o.length - 1][s] === t[s] : o.indexOf(t) === o.length - 1, c = () => n ? o.map((t, e) => ({ ...t, [n]: e })) : o;
  return {
    move: v,
    moveForward: a,
    moveBackward: u,
    items: o,
    isFirstItem: O,
    isLastItem: E,
    updateItems: i
  };
}
const f = "portrait", w = "landscape";
class d {
  constructor(s, n) {
    this.width = s, this.height = n, this.orientation = s > n ? w : f;
  }
  isLandscape() {
    return this.orientation === w;
  }
  isPortrait() {
    return this.orientation === f;
  }
}
const C = (r = window) => {
  const [s, n] = h(
    new d(window.innerWidth, window.innerHeight)
  );
  return L(
    r,
    b(() => {
      n(
        new d(
          (r == null ? void 0 : r.offsetWidth) ?? (r == null ? void 0 : r.innerWidth),
          (r == null ? void 0 : r.offsetHeight) ?? (r == null ? void 0 : r.innerHeight)
        )
      );
    }, [r])
  ), s;
};
function I({ trigger: r }) {
  const s = (n) => {
    n.preventDefault(), n.returnValue = void 0;
  };
  p(() => (r ? window.addEventListener("beforeunload", s) : window.removeEventListener("beforeunload", s), () => window.removeEventListener("beforeunload", s)), [r]);
}
export {
  w as LANDSCAPE,
  k as OrderMove,
  f as PORTRAIT,
  F as useButtonBarShift,
  H as useDrawerBorder,
  T as useDrawerColor,
  g as useOrderer,
  C as useOrientation,
  U as useOutsideClickCallbackEffect,
  L as useResizeObserver,
  W as useScreenBreakpoint,
  I as useUnloadWarning,
  z as useVirtualScroll
};
